import { useState, useContext, useEffect } from "react";
import api from "../../../configs/api";
import { StepTwoParentValidation } from "../RegisterValidation";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Context } from "../../../Context/AuthContext";
import FileDropzone from "../../ui/FileDropzone";
import { ACCEPT_IMAGES_TYPES_OBJECT, ACCEPT_PDF_TYPES_OBJECT, childConditionOptions, MAX_SIZE_IMAGE } from "../../../utils/constants";
import ShowingFile from "../../ui/ShowingFile";
import GeneralSelect from "../../ui/custom-inputs/select-inputs/GeneralSelect";
import CustomInput from "../../ui/custom-inputs/CustomInput";
function ParentStepTwo({ setStep, formData, handleChange, setFormData }) {

  const [childReport, setChildReport] = useState(formData?.childReport?.length ? formData?.childReport : []);
  const [formErrors, setFormErrors] = useState({});
  const { values } = useContext(Context);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = StepTwoParentValidation(formData)

    if (Object.keys(err).length === 0) {
      setFormErrors(err);
      
      try {

        const response = await api.post("/register/new_user", { 
          ...formData, 
          childReport: formData?.childReport.map(file => file.fileUrl),
          childCondition: formData.childCondition === "Other" ? formData.customCondition : formData.childCondition
        });

        Swal.fire({
          icon: "success",
          title: "تم ارسال طلبك للتحقق",
          text: "يمكنك استخدام ظل بعد قبول طلبك",
          customClass: "swal-wide",
        });
        values.logIn.setIsLog(true);

        navigate("/");
      } catch (error) {
        console.error("API error:", error);
        const errorMessage = error?.response?.data?.error;
        Swal.fire({
          icon: "error",
          title: "نعتذر هنالك خطأ ما!",
          text: errorMessage,
          customClass: "swal-wide",
        });
      }
    } else {
      setFormErrors(err);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setStep(1);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      childReport: childReport
    })
  }, [childReport])

  return (
    <>
      <form
        className='bg-[#bbb9b4] border p-3 shadow-md rounded-md text-sm  w-[20rem] sm:w-[27rem] '
        onSubmit={handleSubmit}
      >
        <div className=' flex justify-between'>
          <h4 className=' text-white text-sm'> خطوة 2 من اصل 2</h4>
          <h4 className='text-white'> بيانات الطفل</h4>
        </div>
        <div className='w-full bg-gray-200 rounded-full h-1  relative mt-3'>
          <div className='bg-primary h-1 rounded-full  absolute right-0 w-full '></div>
        </div>
        <br />
        <label className=' text-white flex flex-col items-end'>
          اسم الطفل
          <CustomInput
            type='text'
            dir='rtl'
            placeholder='ادخل الاسم الثلاثي'
            name='childName'
            value={formData.childName || ""}
            onChange={handleChange}
          />{" "}
          {formErrors?.childName && (
            <>
              <p className=' text-xs text-red-500'>{formErrors.childName}</p>
            </>
          )}
        </label>
        <br />
        <label className='text-white flex flex-col items-end'>
          تاريخ الميلاد
          <CustomInput
            type='date'
            dir='rtl'
            name='birthday'
            value={formData.birthday || ""}
            onChange={handleChange}
          />{" "}
          {formErrors?.birthday && (
            <>
              <p className=' text-xs text-red-500'>{formErrors.birthday}</p>
            </>
          )}
        </label>
        <br />
        <label
          htmlFor='childCondition'
          className=' text-white block mb-2 text-sm font-medium  text-end '
        >
          حالة الطفل
        </label>
        <GeneralSelect
          options={childConditionOptions}
          handleChange={(val) => {
            setFormData({ ...formData, childCondition: val?.value })
          }}
          defaultValue={formData?.childCondition}
          name={"childCondition"}
        />
        {formData.childCondition === "other" && (
          <CustomInput
            type='text'
            name='customCondition'
            value={formData.customCondition || ""}
            onChange={handleChange}
            placeholder='أدخل الحالة الأخرى...'
            dir='rtl'
          />
        )}
        {formErrors?.childCondition && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors.childCondition}
            </p>
          </>
        )}
        <br />
        <div className=' flex justify-end text-sm'>
          <label
            htmlFor='childReport'
            className='block mb-2 font-medium  text-end text-white '
          >
            ارفاق تقرير بحالة الطفل
          </label>
        </div>
        <FileDropzone
          setState={setChildReport}
          value={childReport}
          filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
          name="childReport"
          maxSize={MAX_SIZE_IMAGE}
        >
        </FileDropzone>
        <ShowingFile values={childReport} setValues={setChildReport} />

        {formErrors?.childReport && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors.childReport}
            </p>
          </>
        )}
        <br />
        <div className=' flex'>
          <button
            onClick={handleClick}
            className='bg-primary text-white rounded-md p-2'
          >
            رجوع للسابق
          </button>
          <input
            value='حفظ وإنشاء حساب جديد'
            type='submit'
            className=' text-center border-2 bg-primary w-3/4 text-white rounded-xl h-10 cursor-pointer '
          />
        </div>
      </form>
    </>
  );
}

export default ParentStepTwo;
